module.exports = __webpack_public_path__ + "img/logo.df79abd1.png";